import { useState } from 'react'
import '../pages/Home.css'

function ItemPopup( { togglePopup, onSubmit, data, onDelete, tags } ) {

    const [label, setLabel] = useState(data?.label || '')

    const [dateActive, setDateActive] = useState(data?.dateDue)
    const [date, setDate] = useState(data?.dateDue || '')

    const [tagActive, setTagActive] = useState(data?.tag)
    const [tagIndex, setTagIndex] = useState(() => {
        if (data == null || data.tag == null || tags == null) return -1
        return tags.indexOf(data.tag)
    })
    const [tag, setTag] = useState(data?.tag || '')

    const [response, setResponse] = useState('')
    const [submitTxt, setSubmitTxt] = useState('Submit!')

    const handleSubmit = async e => {
        e.preventDefault()



        if (label === null || label === '') {
            return setResponse('Please add a label')
        }

        if (dateActive && (date == null || date === '')) {
            return setResponse("Please add a date or uncheck the box")
        }

        if (tagActive && (tag == null || tag === '')) {
            return setResponse("Please add a tag or uncheck the box")
        }

        setSubmitTxt('Sending...')

        const res = {
            label: label
        }

        if (data != null) {
            res._id = data._id
            res.completed = data.completed
            res.dateCreated = data.dateCreated
        }

        
        if (dateActive) {
            res.dateDue = new Date(date).toISOString()
        }

        if (tagActive) {
            res.tag = tag
        }

        const result = await onSubmit(res)
        setResponse(result)
        setSubmitTxt('Submit!')
    }

    const onTagSelect = value => {
        const index = Number(value)
        setTagIndex(index)

        if (index === -1) {
            setTag('')
        }
        else {
            setTag(tags[value])
        }
    }

    return (

        <div className='popup'>
            <div className='form-container'>
                <div className='dark-hover back-btn' onClick={togglePopup}>{"X"}</div>
                <h1 className='form-header'>{data ? "Edit Item" : "New Item"}</h1>
                <form className='form'>
                    <label>Label:</label>
                    <input value={label} placeholder="Enter label name..." tabIndex={1} className='text-field' type="text" autoFocus={true} onChange={e => setLabel(e.target.value)} />
                    <label>Due date:</label>
                    <div className='toggle-input-container'>
                        <div tabIndex={2} className={'toggle toggle-' + (dateActive ? 'on' : 'off')} onClick={() => setDateActive(!dateActive)} onKeyDown={e => { if(e.key === 'Enter') setDateActive(!dateActive)} }/>
                        <input value={date} tabIndex={3} className={'text-field'} type="datetime-local" onChange={e => setDate(e.target.value)} disabled={!dateActive}/>
                    </div>
                    <label>Tag:</label>
                    <div className='toggle-input-container'>
                        <div tabIndex={4} className={'toggle toggle-' + (tagActive ? 'on' : 'off')} onClick={() => setTagActive(!tagActive)} onKeyDown={e => { if(e.key === 'Enter') setTagActive(!tagActive)} }/>
                        <datalist id='tag-list'>
                        </datalist>
                        <div className='tag-input-container'>
                            <select className="dropdown" value={tagIndex} disabled={!tagActive} onChange={e => onTagSelect(e.target.value)}>
                                { tags.map((tag, index) => <option value={index} key={index}>{tag}</option>) }
                                <option value={-1} key={-1}>(Other)</option>
                            </select>
                            {(tagIndex === -1) ? <input className='text-field' placeholder='Enter tag name...' tabIndex={5} maxLength="20"  disabled={!tagActive} onChange={e => setTag(e.target.value)}/> : ''}
                        </div>
                        
                    </div>
                    <div tabIndex={6} className='dark-hover submit-btn' onClick={handleSubmit} onKeyDown={async (e) => { if (e.key === 'Enter') await handleSubmit(e) } }>{submitTxt}</div>
                    {data ? (<div className='dark-hover delete-btn' onClick={() => onDelete(data)}>Delete</div>) : ''}
                    <label className='response-text'>{response}</label>
                </form>
            </div>
        </div>
    )
}

// Track position
let pos;

// On scroll update position
document.body.addEventListener("scroll", function() {
  pos = document.body.scrollTop;
}, true);

// On rotation apply the scroll position
window.addEventListener("orientationchange", function() {
  document.body.scrollTop = pos;
}, true);

export default ItemPopup;